import logoDark from "./assets/logo-dark.png";
import logoLight from "./assets/logo.png";
import "./hubBrand.css";

/**
 * The organisation's mark, wherever the portal names itself.
 *
 * One component rather than an `<img>` repeated in six places, because the
 * two things that are easy to get wrong here are easy to get wrong
 * inconsistently: which file the current surface needs, and what a screen
 * reader is told. Both are decided once, here.
 *
 * ## Two files, not a CSS filter
 *
 * The mark is black type beside a red rule. Inverting it in CSS would take the
 * red to cyan, so the dark variant is a separate image with only the near-black
 * ink remapped and the red left exactly as drawn.
 *
 * Both variants are present so CSS can follow the actual Hub surface rather
 * than only the operating-system theme. Normally the media query chooses the
 * variant; an accessibility palette can override that choice through inherited
 * display tokens when its background differs from the system theme.
 */
export function Brand({
  title,
  subtitle,
  className,
}: {
  /** The organisation. Becomes the mark's accessible name, so it is never lost. */
  title: string;
  /** Which Hub this is: "Staff Hub", "Student Hub", "Hub". */
  subtitle: string;
  className?: string;
}) {
  return (
    <div className={className ? `brand ${className}` : "brand"}>
      <span className="brand-logo" role="img" aria-label={title}>
        <img
          className="brand-mark brand-mark--light-bg"
          src={logoLight}
          alt=""
          aria-hidden="true"
        />
        <img
          className="brand-mark brand-mark--dark-bg"
          src={logoDark}
          alt=""
          aria-hidden="true"
        />
      </span>
      <small className="brand-subtitle">{subtitle}</small>
    </div>
  );
}
